import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0 size-full',
    tabs: 'w-full',
    tab: 'flex-1',
    panelContent:
      'relative h-(--pickup-tab-content-height,min(680px,80vh)) w-full',
    pickupPointSelector: 'absolute z-50',
    searchLocationField: ''
  },
  variants: {
    mobileView: {
      false: {
        searchLocationField:
          'absolute top-8 right-[calc(40px+var(--pickup-additional-offset,0px))] left-115 z-50 hidden lg:block xl:left-125'
      },
      true: {
        searchLocationField:
          'absolute top-8 left-1/2 z-50 w-[90%] max-w-[600px] origin-center -translate-x-1/2 scale-100 overflow-visible rounded-md bg-white opacity-100 shadow-md transition-all duration-300 ease-in-out'
      }
    },
    size: {
      small: {
        pickupPointSelector: 'inset-y-4 left-4'
      },
      default: {
        pickupPointSelector: 'inset-y-8 left-6 xl:left-10'
      }
    }
  }
});
